import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    continue: 'Send your avis SIRENE',
    description:
      'We have to make sure your company has been registered.\n\nFor this you just have to send us your avis SIRENE that you should have received by mail.',
    fileName: 'Company registration document',
    headline: 'Add your avis SIRENE',
    helpLink: 'How can I get this document?',
    uploadHelper:
      '**To get your account opened faster, make sure your avis SIRENE meets the following criteria :**',
    uploadHelperItem:
      'The document must be **readable and intelligible**. We recommend the **PDF format**.',
  },
  fr: {
    continue: 'Envoyer votre avis SIRENE',
    description:
      'Nous devons nous assurer que la création de votre entreprise a bien été effectuée.\n\nPour ce faire, il suffit juste de nous transmettre votre avis SIRENE que vous avez dû recevoir par courrier.',
    fileName: 'Justificatif d’immatriculation de l’entreprise',
    headline: 'Ajouter votre avis SIRENE',
    helpLink: 'Comment obtenir ce document ?',
    uploadHelper:
      '**Pour que votre compte soit validé au plus vite, assurez-vous que votre SIRENE respecte les critères suivants :**',
    uploadHelperItem:
      'Le document doit être entièrement **lisible**, net et non découpé. Nous recommandons fortement le **format PDF**.',
  },
});

export default locales;
